import { Component, inject, Input } from '@angular/core';
import { AnomalyUtilService as BudaAnomalyUtilService } from '@buda/app/services/util/anomaly-util.service';
import { Anomaly, AnomalyDetailsProperties } from '@buda/app/types/anomaly.types';

@Component({
  selector: 'table-column-anomaly-detail',
  templateUrl: './table-column-anomaly-detail.component.html',
  standalone: false,
})
export class TableColumnAnomalyDetailComponent {
  @Input() element: Anomaly;

  displayedAnomalyDetails?: AnomalyDetailsProperties[] = [
    AnomalyDetailsProperties.alertTime,
    AnomalyDetailsProperties.duration,
  ];

  private readonly anomalyUtilService: BudaAnomalyUtilService;

  constructor() {
    const budaAnomalyUtilService = inject(BudaAnomalyUtilService, { optional: true });

    this.anomalyUtilService = budaAnomalyUtilService;
  }

  formatData(anomalyDetailsProperties: AnomalyDetailsProperties): string {
    return this.anomalyUtilService.getFormattedAnomalyDetailsData(this.element, anomalyDetailsProperties);
  }
}
